import {css, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import doctorIcon from 'src/assets/icons/doctorIcon.svg';
import {GetStylesFunction} from 'src/js/common/types';

type Props = any;

export const DlMuiDoctorIcon: React.FC<Props> = (props) => {
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <SvgIcon
      css={styles.doctorIcon}
      component={doctorIcon}
      inheritViewBox
      {...props}
    />
  );
};

DlMuiDoctorIcon.displayName = 'DlMuiDoctorIcon';

const getStyles: GetStylesFunction = (options) => ({
  doctorIcon: css`
    width: 24px;
    height: 24px;
  `,
});
